module.exports = "/assets/landing-rc/promo/delice-photo.jpg?Zcj6IQs";